import React, { FC } from 'react';
import styles from './image-box.module.scss';
import image1 from '../../assets/images/resource/about-img-1.jpg';
import image2 from '../../assets/images/resource/about-img-2.jpg';
import image3 from '../../assets/images/resource/about-img-3.jpg';
import image4 from '../../assets/images/resource/about-img-4.jpg';
import image5 from '../../assets/images/resource/about-img-5.jpg';
import image6 from '../../assets/images/resource/about-img-6.jpg';

interface ImageBoxProps {}

const ImageBox: FC<ImageBoxProps> = () => {
  const imgContent = [
    {
      id: 1,
      block: [{ img: image1 }],
    },
    {
      id: 2,
      block: [{ img: image2 }, { img: image3 }],
    },
    {
      id: 3,
      block: [{ img: image4 }, { img: image5 }],
    },
    {
      id: 4,
      block: [{ img: image6 }],
    },
  ];
  
  return (
    <div className="images-box">
      <div className="row">
        {imgContent.map((item) => (
          <div className="column col-lg-3 col-md-6 col-sm-6" key={item.id}>
            {item.block.map((itemImg, i) => (
              <figure className="image" key={i}>
                <img
                  src={itemImg.img}
                  alt="about image"
                  width={300}
                  height={200}
                />
              </figure>
            ))}
          </div>
        ))}
        {/* End .col */}
      </div>
    </div>
  );
}
export default ImageBox;
